import my from "../my";

/**
 * 清空千牛的token缓存
 */
export default function cleanQnToken() {
    my.qn.cleanToken();
}
